import React, { useEffect } from 'react';

export default function PropietarioInformes({
  anioInforme,
  setAnioInforme,
  mesInforme,
  setMesInforme,
  informesFiltrados,
  abrirArchivoConLimiteGlobal,
  todosLosInformesAnuales = [],
  // 📂 Nuevas props para documentos permanentes
  documentosPermanentes = []
}) {
  const aniosDisponibles = ['2024', '2025', '2026', '2027', '2028', '2029', '2030'];
  const mesesDisponibles = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Setiembre', 'Octubre', 'Noviembre', 'Diciembre', 'Unitario'];

  // 🤖 SALTO AUTOMÁTICO A "UNITARIO": 
  useEffect(() => {
    const elMesActualEstaVacio = informesFiltrados.filter(inf => inf.mes !== 'Unitario').length === 0;
    const hayInformesUnitarios = informesFiltrados.some(inf => inf.mes === 'Unitario');

    if (elMesActualEstaVacio && hayInformesUnitarios && mesInforme !== 'Unitario') {
      setMesInforme('Unitario');
    }
  }, [informesFiltrados, mesInforme, setMesInforme]);

  return (
    <div style={{ backgroundColor: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '16px', padding: '20px', boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.05)', boxSizing: 'border-box', width: '100%', maxWidth: '100%', overflowX: 'hidden' }}>
      
      {/* Encabezado Principal */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
        <div style={{ backgroundColor: '#e0f2fe', color: '#0284c7', width: '40px', height: '40px', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem', boxShadow: '0 4px 6px -1px rgba(2, 132, 199, 0.2)', flexShrink: 0 }}>
          🏢
        </div>
        <h3 style={{ margin: 0, color: '#0f172a', fontSize: '1.3rem', fontWeight: '800', wordBreak: 'break-word' }}>
          Gestión y Archivo
        </h3>
      </div>
      <p style={{ color: '#64748b', fontSize: '0.9rem', marginBottom: '20px', lineHeight: '1.5' }}>
        Consulta aquí los informes financieros, reportes de mantenimiento, actas y acuerdos tomados en las reuniones de la junta de propietarios.
      </p>

      {/* 📚 SECCIÓN DE DOCUMENTOS PERMANENTES (NORMATIVA) */}
      <div style={{ marginBottom: '25px', background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)', border: '1px solid #bbf7d0', borderRadius: '14px', padding: '18px', boxShadow: '0 4px 6px -1px rgba(22, 163, 74, 0.05)', boxSizing: 'border-box' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
          <span style={{ fontSize: '1.2rem', flexShrink: 0 }}>📖</span>
          <h4 style={{ color: '#166534', margin: 0, fontSize: '1.1rem', fontWeight: '700', wordBreak: 'break-word' }}>
            Normativa y Documentos Permanentes
          </h4>
        </div>
        <p style={{ fontSize: '0.88rem', color: '#15803d', marginBottom: '16px', lineHeight: '1.4' }}>
          Reglamentos internos, manuales de convivencia y normativas generales de consulta permanente.
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '12px' }}>
          {documentosPermanentes.length === 0 ? (
            <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '16px', color: '#166534', fontStyle: 'italic', fontSize: '0.85rem', backgroundColor: 'rgba(255, 255, 255, 0.7)', borderRadius: '10px', border: '1px dashed #86efac', boxSizing: 'border-box' }}>
              No hay documentos permanentes publicados por la administración.
            </div>
          ) : (
            documentosPermanentes.map(docPerm => (
              <div key={docPerm.id} style={{ backgroundColor: 'white', border: '1px solid #bbf7d0', borderRadius: '10px', padding: '16px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', boxShadow: '0 2px 4px rgba(0,0,0,0.02)', boxSizing: 'border-box', overflow: 'hidden' }}>
                <h4 style={{ margin: '0 0 10px 0', color: '#0f172a', fontSize: '0.92rem', fontWeight: '600', wordBreak: 'break-word', display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
                  <span style={{ color: '#16a34a', flexShrink: 0 }}>📄</span> <span>{docPerm.descripcion || docPerm.nombre}</span>
                </h4>
                <div>
                  <button 
                    type="button"
                    onClick={() => abrirArchivoConLimiteGlobal(docPerm.archivoUrl, docPerm.id)}
                    style={{ backgroundColor: '#f0fdf4', color: '#15803d', border: '1px solid #bbf7d0', padding: '8px 12px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '6px', fontSize: '0.85rem', width: '100%', boxSizing: 'border-box' }}
                  >
                    <span>Ver Documento</span> <span>↗</span>
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      <div style={{ height: '1px', backgroundColor: '#e2e8f0', margin: '20px 0' }} />

      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
        <span style={{ fontSize: '1.2rem', flexShrink: 0 }}>📊</span>
        <h4 style={{ color: '#0f172a', margin: 0, fontSize: '1.1rem', fontWeight: '700', wordBreak: 'break-word' }}>Informes Financieros y Mensuales</h4>
      </div>

      {/* Barra de Filtros Desplegables */}
      <div style={{ backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '14px', padding: '18px', marginBottom: '20px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', alignItems: 'center', boxShadow: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.02)', boxSizing: 'border-box' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%', boxSizing: 'border-box' }}>
          <label style={{ fontWeight: '700', fontSize: '0.82rem', color: '#475569', textTransform: 'uppercase', letterSpacing: '0.5px' }}>📅 Seleccionar Año:</label>
          <select 
            value={anioInforme} 
            onChange={e => setAnioInforme(e.target.value)} 
            style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid #cbd5e1', fontSize: '0.92rem', backgroundColor: 'white', cursor: 'pointer', fontWeight: '600', color: '#1e293b', outline: 'none', boxSizing: 'border-box' }}
          >
            {aniosDisponibles.map(a => <option key={a} value={a}>{a}</option>)}
          </select>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%', boxSizing: 'border-box' }}>
          <label style={{ fontWeight: '700', fontSize: '0.82rem', color: '#475569', textTransform: 'uppercase', letterSpacing: '0.5px' }}>🗓️ Seleccionar Mes / Tipo:</label>
          <select 
            value={mesInforme} 
            onChange={e => setMesInforme(e.target.value)} 
            style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '1px solid #cbd5e1', fontSize: '0.92rem', backgroundColor: 'white', cursor: 'pointer', fontWeight: '600', color: '#1e293b', outline: 'none', boxSizing: 'border-box' }}
          >
            {mesesDisponibles.map(m => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>
        </div>
      </div>

      {/* Aviso si está filtrando un informe unitario especial */}
      {mesInforme === 'Unitario' && (
        <div style={{ backgroundColor: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '10px', padding: '12px 15px', marginBottom: '20px', color: '#1e40af', fontSize: '0.88rem', display: 'flex', alignItems: 'center', gap: '10px', boxSizing: 'border-box', wordBreak: 'break-word' }}>
          <span style={{ fontSize: '1.2rem', flexShrink: 0 }}>ℹ️</span>
          <div>Estás visualizando los <strong>Informes Unitarios / Especiales</strong> globales del edificio para el año {anioInforme}.</div>
        </div>
      )}

      {/* Listado de Informes Filtrados */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: '15px' }}>
        {informesFiltrados.length === 0 ? (
          <div style={{ gridColumn: '1 / -1', backgroundColor: '#f8fafc', border: '1px dashed #cbd5e1', borderRadius: '12px', padding: '30px 15px', textAlign: 'center', color: '#64748b', boxSizing: 'border-box' }}>
            <p style={{ margin: 0, fontStyle: 'italic', fontSize: '0.9rem' }}>No hay registros disponibles para <strong>{mesInforme}</strong> de <strong>{anioInforme}</strong>.</p>
          </div>
        ) : (
          informesFiltrados.map(inf => (
            <div key={inf.id} style={{ backgroundColor: 'white', border: '1px solid #e2e8f0', borderRadius: '12px', padding: '18px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.02)', transition: 'all 0.2s ease', boxSizing: 'border-box', overflow: 'hidden' }}>
              <div>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', marginBottom: '10px' }}>
                  <span style={{ fontSize: '1.2rem', padding: '6px', backgroundColor: '#f1f5f9', borderRadius: '8px', flexShrink: 0 }}>📑</span>
                  <h4 style={{ margin: 0, color: '#0f172a', fontSize: '0.98rem', fontWeight: '700', lineHeight: '1.4', wordBreak: 'break-word' }}>{inf.descripcion}</h4>
                </div>
                <p style={{ fontSize: '0.8rem', color: '#64748b', margin: '0 0 12px 0', paddingLeft: '38px', wordBreak: 'break-word' }}>Subido el: {inf.fechaSubida || 'Fecha reciente'}</p>
              </div>
              <div>
                <button 
                  type="button"
                  onClick={() => abrirArchivoConLimiteGlobal(inf.archivoUrl, inf.id)}
                  style={{ backgroundColor: '#f0f9ff', color: '#0284c7', border: '1px solid #bae6fd', padding: '10px 14px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '6px', width: '100%', fontSize: '0.88rem', boxSizing: 'border-box' }}
                >
                  <span>Ver Archivo</span> <span>↗</span>
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}